import React from 'react';
import Clients from './Clients';
import Cta from './Cta';
import Footer from './Footer';
import Hero from './Hero';
import Intro from './Intro';
import Portfolio from './Portfolio';
import Certification from './Certification';
import ScrollToTop from './ScrollToTop';
import Contact from './Contact';




const Home = () => {
    return (
        <>
            <Hero />
            <Intro />
            <Certification />          
            <Portfolio />
            <Clients />
            <ScrollToTop /> 
            <Cta/>
            <Contact/>
            <Footer />
        </>

    )
}

export default Home;

